import {
  AfterViewInit,
  Component,
  forwardRef,
  Input,
  ViewChild
} from '@angular/core';
import {
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import {SyncValidatorComponent} from '../utils/base.component';
import {FirebaseService} from '../app/firebase.service';
import {User} from '../app/user';
import {config} from '../app/config';

@Component({
  selector: 'app-stammdaten',
  templateUrl: './stammdaten.component.html',
  styles: [],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => StammdatenComponent)
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: forwardRef(() => StammdatenComponent)
    }
  ]
})
export class StammdatenComponent extends SyncValidatorComponent implements AfterViewInit {
  @Input()
  user: User;
  @Input()
  admin: boolean;
  geburtsdatumMin = config.geburtsdatumMin;
  geburtsdatumInit = config.geburtsdatumInit;
  geburtsdatumMax = config.geburtsdatumMax;
  @ViewChild('formGroup') formGroup: FormGroup;

  constructor(public service: FirebaseService) {
    super();
  }

  ngAfterViewInit() {
    this.formGroup.statusChanges.subscribe(x => this.triggerValidation());
  }

  validate(c: FormControl) {
    const err = {
      requiredError: {
        r: 'required!'
      }
    };
    return this.formGroup && this.formGroup.valid ? null : err;
  }

  storeStammdaten() {
    if (this.formGroup.valid || this.admin) {
      this.service.storeStammdaten(this.user);
    }
  }

  get readonlyName(): boolean {
    return this.user.readonlyName && !this.admin;
  }
}
